import { render, staticRenderFns } from "./PracticeDetails.vue?vue&type=template&id=1333fd66&scoped=true&"
import script from "./PracticeDetails.vue?vue&type=script&lang=js&"
export * from "./PracticeDetails.vue?vue&type=script&lang=js&"
import style0 from "./PracticeDetails.vue?vue&type=style&index=0&id=1333fd66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1333fd66",
  null
  
)

export default component.exports